import { render, staticRenderFns } from "./VendorProducts.vue?vue&type=template&id=15f92e7a&scoped=true&"
import script from "./VendorProducts.vue?vue&type=script&lang=js&"
export * from "./VendorProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f92e7a",
  null
  
)

export default component.exports